import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncTracker } from '@sg/utils/src';
import { ActionClickEvent, CollateralTypesToDisplay, LocateMatch } from '../../models';

@Component({
  selector: 'sg-action-cell',
  templateUrl: './action-cell.component.html',
  styleUrls: ['./action-cell.component.scss'],
  standalone: false,
})
export class SgActionCellComponent {
  @Input() locateMatch: LocateMatch;
  @Input() tracker: AsyncTracker;
  @Input() collateralsToDisplay: CollateralTypesToDisplay;
  @Output() onClick = new EventEmitter<ActionClickEvent>();
}
